import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';

import EditProjectPage from './EditProjectPage';
import ProjectDetail from './ProjectDetailPage';
import AddProjectPage from './AddProjectPage';
import ProjectsPage from './ProjectsPage';
import SectionHorizonSequence from './sections/TractComponents/SectionHorizonSequence';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="projects-page" path="/projects" component={ProjectsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="add-project" path="/clients/:clientNumber/add-project" component={AddProjectPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate
            key="edit-project"
            path="/clients/:clientNumber/projects/:projectNumber/edit-project"
            component={EditProjectPage}
            isLoggedIn={isLoggedIn}
        />,
        <RoutePrivate
            key="sequence-section"
            path="/clients/:clientNumber/projects/:projectNumber/sections/:sectionNumber/section-horizon-sequence"
            component={SectionHorizonSequence}
            isLoggedIn={isLoggedIn}
        />,
        <RoutePrivate key="client-detail" path="/clients/:clientNumber/projects/:projectNumber" component={ProjectDetail} isLoggedIn={isLoggedIn} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/project/Project.Routes.tsx